// Blower vertex schema
// Active gas/air device.

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema } from '../base/common';
import { BlowerOperationConfigSchema } from '../base/active-device-operation';
import { BlowerCurveSchema } from '../base/curves';

export const BlowerVertexSchema = BaseVertexSchema.extend({
  type: z.literal('blower'),
  elevation: ValueWithUnitSchema,
  blower_curve: BlowerCurveSchema.optional(),
  operation: BlowerOperationConfigSchema,
});

export type BlowerVertex = z.infer<typeof BlowerVertexSchema>;
